/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingSellerAgencyResponseDto } from './listingSellerAgencyResponseDto';
import type { ListingSellerContactResponseDtoRole } from './listingSellerContactResponseDtoRole';

export interface ListingSellerContactResponseDto {
  name: string;
  /** @nullable */
  phoneHint: string | null;
  /** @nullable */
  phone: string | null;
  /** @nullable */
  photoUrl: string | null;
  /** @nullable */
  role: ListingSellerContactResponseDtoRole;
  /** @nullable */
  agency: ListingSellerAgencyResponseDto | null;
}
